// extracted by mini-css-extract-plugin
export default {"root":"profiles_page-module___root___feab9ff2"};